import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Stack } from '@mui/material';
// components
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
import { MHidden } from '../../components/@material-extend';
//
import sidebarConfig from './SidebarConfig';
import account from '../../_mocks_/account';
import axios from 'axios';
import { Icon } from "@iconify/react";

// icons
import pieChart2Fill from "@iconify/icons-eva/pie-chart-2-fill";
import peopleFill from "@iconify/icons-eva/people-fill";
import lockFill from "@iconify/icons-eva/lock-fill";
import settingFill from "@iconify/icons-eva/settings-fill";
import shoppingCartFill from "@iconify/icons-eva/shopping-cart-fill";
import percentFill from "@iconify/icons-eva/percent-fill";
import layoutFill from "@iconify/icons-eva/layout-fill";
import imageFill from "@iconify/icons-eva/image-fill";
import castFill from "@iconify/icons-eva/cast-fill";
import briefcseFill from "@iconify/icons-eva/briefcase-fill";
import funnelFill from "@iconify/icons-eva/funnel-fill";
import colorPaletteFill from "@iconify/icons-eva/color-palette-fill";
import fileTextFill from "@iconify/icons-eva/file-text-fill";
import phoneCallFill from "@iconify/icons-eva/phone-call-fill";
import downloadFill from "@iconify/icons-eva/download-fill";
import shoppingFill from "@iconify/icons-eva/shopping-bag-fill";
import inboxFill from "@iconify/icons-eva/inbox-fill";
import { COMP_NAME, ROLE } from 'src/config/constants';
import { useSelector } from 'react-redux';

// ----------------------------------------------------------------------
const getIcon = (name) => {
  let icon = null;
  switch(name) {
    case 'pie-chart-2-fill': icon = pieChart2Fill; break;
    case 'people-fill': icon = peopleFill; break;
    case 'lock-fill': icon = lockFill; break;
    case 'settings-fill': icon = settingFill; break;
    case 'shopping-cart-fill': icon = shoppingCartFill; break;
    case 'percent-fill': icon = percentFill; break;
    case 'image-fill': icon = imageFill; break;
    case 'cast-fill': icon = castFill; break;
    case 'briefcase-fill': icon = briefcseFill; break;
    case 'layout-fill': icon = layoutFill; break;
    case 'funnel-fill': icon = funnelFill; break;
    case 'color-palette-fill': icon = colorPaletteFill; break;
    case 'file-text-fill': icon = fileTextFill; break;
    case 'phone-call-fill': icon = phoneCallFill; break;
    case 'download-fill': icon = downloadFill; break;
    case 'shopping-bag-fill': icon = shoppingFill; break;
    case 'inbox-fill': icon = inboxFill; break;
  }
  return <Icon icon={icon} width={22} height={22} />
};

const DRAWER_WIDTH = 280;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH
  }
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadiusSm,
  backgroundColor: theme.palette.grey[200]
}));

// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { username, title } = useSelector((state) => state.userInfo.userInfo);
  const { pathname } = useLocation();

  const [menus, setMenus] = useState([]);

  useEffect(() => {
    axios
      .get("/system/menu/my")
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          if (!data.length) return;
          const menus = [...data];
          menus.sort((a, b) => b.order - a.order);

          const levels = [];

          for (let i = 0; i < menus.length; i++) {
            // if (!menus[i].isMenu) continue;
            const level = (menus[i].level || 1) - 1;
            if (!levels[level]) {
              levels[level] = [];
            }

            levels[level].push({
              ...menus[i],
              icon: getIcon(menus[i].icon),
            });
          }

          for (let i = levels.length - 1; i > 0; i--) {
            for (let j = 0; j < levels[i].length; j++) {
              const parentGroup = levels[i - 1];
              const parent = parentGroup.find((p) => p.id === levels[i][j].pid);

              if (!parent) continue; // 不分父级没显示
              if (!parent.children) {
                parent.children = [];
              }

              parent.children.push(levels[i][j]);
            }
          }

          setMenus(levels[0]);
        }
      })
      .catch((err) => {
        console.log(err)
      });
  }, []);

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: '100%',
        '& .simplebar-content': { height: '100%', display: 'flex', flexDirection: 'column' }
      }}
    >
      <Box sx={{ px: 2.5, py: 3 }} display="flex" flexDirection="row">
        <Box component={RouterLink} to="/" sx={{ display: 'inline-flex' }}>
          <Logo />
        </Box>

        <Typography
          variant="h5"
          sx={{
            mt: 1,
            ml: 1,
          }}
        >
          {title || COMP_NAME}
          {ROLE == 'merchant' ? '(商家端)' : ''}
          {ROLE == 'agent' ? '(代理端)' : ''}
          {ROLE == 'supplier' ? '(供应商)' : ''}
        </Typography>
      </Box>

      <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none" component={RouterLink} to="#">
          <AccountStyle>
            <Avatar src={account.photoURL} alt="photoURL" />
            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {username}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {account.role}
              </Typography>
            </Box>
          </AccountStyle>
        </Link>
      </Box>

      {/* <NavSection navConfig={sidebarConfig} /> */}
      <NavSection navConfig={menus} />

      <Box sx={{ flexGrow: 1 }} />

      {/* <Box sx={{ px: 2.5, pb: 3, mb: 2 }}>
        <Stack
          alignItems="center"
          spacing={3}
          sx={{
            p: 2.5,
            pt: 5,
            borderRadius: 2,
            position: 'relative',
            bgcolor: 'grey.200'
          }}
        >
          <Box
            component="img"
            src={`${process.env.PUBLIC_URL}admin/static/illustrations/illustration_avatar.png`}
            sx={{ width: 100, position: 'absolute', top: -50 }}
          />

          <Box sx={{ textAlign: 'center' }}>
            <Typography gutterBottom variant="h6">
              Get more?
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              From only $69
            </Typography>
          </Box>

          <Button
            fullWidth
            href="https://material-ui.com/store/items/minimal-dashboard/"
            target="_blank"
            variant="contained"
          >
            Upgrade to Pro
          </Button>
        </Stack>
      </Box> */}
    </Scrollbar>
  );

  return (
    <RootStyle>
      <MHidden width="lgUp">
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>

      <MHidden width="lgDown">
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default'
            }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>
    </RootStyle>
  );
}
